import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useQueryClient } from 'react-query';
import { CerebroDrawer, CerebroHeading, CerebroInput, CerebroLabel, CerebroPrimaryButton, CerebroText } from '../../../shared/components';
import { useApi } from '../../../shared/context';
import { DealPartnerContact } from '../../../shared/models';
import { CerebroApiEndpoints } from '../../../shared/utils/api';
import { getResponseData } from '../../../shared/utils/axios';

interface SendAccountInfoProps {
	dataRoomGuid: string | undefined;
	contact: DealPartnerContact | null;
	close: () => void;
}

export const SendAccountInfoForm: React.FC<SendAccountInfoProps> = ({ dataRoomGuid, contact, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();

	const sendInvite = async () => {
		await getResponseData<DealPartnerContact>(
			api.post(CerebroApiEndpoints.DataRoomPartnerContacts.SendAccountInfo(dataRoomGuid, contact?.guid))
		);

		snackbar.enqueueSnackbar('Successfully sent Cerebro invite.', { variant: 'success' });
        close();
	};

	return (
		<CerebroDrawer open={contact != null} onClose={() => close()}>
			<CerebroHeading>Send Cerebro Invitation</CerebroHeading>
            <CerebroText variant='hint'>Send a platform invite to the selected company contact.</CerebroText>

			<Grid container spacing={3} sx={{ marginTop: 3 }} justifyContent={{ xs: 'center', md: 'flex-start' }}>
				<CerebroLabel id='email'>To</CerebroLabel>
                <CerebroInput id='email' name='email' disabled={true} placeholder={contact?.emailAddress}></CerebroInput>
				<Grid item xs={12}>
					<CerebroPrimaryButton onClick={() => sendInvite()}>Send Invite</CerebroPrimaryButton>
				</Grid>
			</Grid>
		</CerebroDrawer>
	);
};
